import { ScreenWidth } from "utils/screenDimensions.utils";

/*
 * Password Requirements:
 *  - 8 Characters
 *  - 1 Number
 *  - 1 Uppercase Letter
 *  - 1 Lowercase Letter
 *  - 1 Special Character (@$!%*?&)
 */
export const PHONE_REQUIREMENTS =
  //eslint-disable-next-line no-useless-escape
  /^[\+]?[1-9]?[\-\s\.]?\(?[0-9]{3}\)?[\-\s\.]?[0-9]{3}[\-\s\.]?[0-9]{4}$/;
export const ZIPCODE_REQUIREMENTS = /^\d{5}$/;
// Terms & Service Text

/* eslint-disable max-len */
export const TERMS_SERVICE_TEXT = `
Last revised: June 16, 2020

Introduction
These Terms of Use apply to NorthcrossGroup.com or the NCG practice specific website that you were viewing before clicking on these Terms of Use. Such individual website is referred to in these Terms of Use as "this Website." Northcross Group is providing this Website and is referred to in these Terms of Use as "we," "us," or "our."

By using this Website, you are agreeing to these Terms of Use. If you do not agree to these Terms of Use, then you are not allowed to use this Website and should immediately terminate such usage.
Use of Content; Restrictions; Privacy Statement
Unless otherwise indicated in the relevant content, and on the condition that you comply with all of your obligations under these Terms of Use, you are authorized to view, copy, print, and distribute (but not modify) the content on this Website; provided that (i) such use is for informational, noncommercial purposes only, and (ii) any copy of the content that you make must include the copyright notice or other attribution associated with the content.

You are not authorized to copy or use any software, proprietary processes, or technology embodied or described in this Website.

You will comply with all applicable laws in accessing and using this Website.

You acknowledge that we may use your personal information and data and any confidential information you provide to us according to our Privacy Statement and its accompanying Cookie Notice, which are incorporated herein by this reference. By using this Website, you are also agreeing to the terms of our Privacy Statement and Cookie Notice, including any obligations imposed on you therein.

Intellectual Property Rights; No use of Northcross Group names or logos

Unless otherwise indicated, the content on this Website is provided by us. This Website and its contents are protected by copyright, trademark, and other laws of the United States and/or foreign countries. We and our licensors reserve all rights not expressly granted in these Terms of Use.

“Northcross Group,” “NCG,” the NCG logo, the Northcross Group logo, and local language variants of the foregoing trademarks, and certain product names that appear on this Website (collectively, the “Northcross Group Marks”), are trademarks or registered trademarks of Northcross Group. Except as expressly provided in these Terms of Use or as expressly authorized in writing by the relevant trademark owner, you shall not use any Northcross Group Marks either alone or in combination with other words or design elements, including, in any press release, advertisement, or other promotional or marketing material or media, whether in written, oral, electronic, visual, or any other form.

References to other parties trademarks on this Website are for identification purposes only and do not indicate that such parties have approved this Website or any of its contents. These Terms of Use do not grant you any right to use the trademarks of other parties.

Disclaimers and Limitations of Liability
THIS WEBSITE (INCLUDING, WITHOUT LIMITATION, ANY CONTENT OR OTHER PART THEREOF) CONTAINS GENERAL INFORMATION ONLY, AND WE ARE NOT, BY MEANS OF THIS WEBSITE, RENDERING PROFESSIONAL ADVICE OR SERVICES. BEFORE MAKING ANY DECISION OR TAKING ANY ACTION THAT MIGHT AFFECT YOUR FINANCES OR BUSINESS, YOU SHOULD CONSULT A QUALIFIED PROFESSIONAL ADVISOR.

THIS WEBSITE IS PROVIDED AS IS, AND WE MAKE NO EXPRESS OR IMPLIED REPRESENTATIONS OR WARRANTIES REGARDING IT. WITHOUT LIMITING THE FOREGOING, WE DO NOT WARRANT THAT THIS WEBSITE WILL BE SECURE, ERROR-FREE, FREE FROM VIRUSES OR MALICIOUS CODE, OR WILL MEET ANY PARTICULAR CRITERIA OF PERFORMANCE OR QUALITY. WE EXPRESSLY DISCLAIM ALL IMPLIED WARRANTIES, INCLUDING, WITHOUT LIMITATION, WARRANTIES OF MERCHANTABILITY, TITLE, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, COMPATIBILITY, SECURITY, AND ACCURACY.

YOUR USE OF THIS WEBSITE IS AT YOUR OWN RISK AND YOU ASSUME FULL RESPONSIBILITY AND RISK OF LOSS RESULTING FROM YOUR USAGE, INCLUDING, WITHOUT LIMITATION, WITH RESPECT TO LOSS OF SERVICE OR DATA. WE WILL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES OR ANY OTHER DAMAGES WHATSOEVER, WHETHER IN AN ACTION OF CONTRACT, STATUTE, TORT (INCLUDING, WITHOUT LIMITATION, NEGLIGENCE), OR OTHERWISE, RELATING TO OR ARISING OUT OF THE USE OF THIS WEBSITE, EVEN IF WE KNEW, OR SHOULD HAVE KNOWN, OF THE POSSIBILITY OF SUCH DAMAGES.

CERTAIN LINKS ON THIS WEBSITE MAY LEAD TO WEBSITES, RESOURCES, OR TOOLS MAINTAINED BY THIRD PARTIES OVER WHOM WE HAVE NO CONTROL. WITHOUT LIMITING ANY OF THE FOREGOING, WE MAKE NO EXPRESS OR IMPLIED REPRESENTATIONS OR WARRANTIES WHATSOEVER REGARDING SUCH WEBSITES, RESOURCES, AND TOOLS, AND LINKS TO ANY SUCH WEBSITES, RESOURCES, AND TOOLS SHOULD NOT BE CONSTRUED AS AN ENDORSEMENT OF THEM OR THEIR CONTENT BY US.

THE ABOVE DISCLAIMERS AND LIMITATIONS OF LIABILITY ARE APPLICABLE TO THE FULLEST EXTENT PERMITTED BY LAW, WHETHER IN CONTRACT, STATUTE, TORT (INCLUDING, WITHOUT LIMITATION, NEGLIGENCE), OR OTHERWISE.

Additional Terms
If any portion of these Terms of Use is invalid or unenforceable in any jurisdiction, then (i) in that jurisdiction it shall be re-construed to the maximum effect permitted by law in order to effect its intent as nearly as possible, and the remainder of these Terms of Use shall remain in full force and effect, and (ii) in every other jurisdiction, all of these Terms of Use shall remain in full force and effect.

We may revise these Terms of Use at any time in our sole discretion by posting such revised Terms of Use at the Terms of Use link (i.e., this webpage that you are currently viewing) or elsewhere in this Website. Such revisions shall be effective as to you upon posting, unless explicitly stated by us. It is your responsibility to be aware of any such revised Terms of Use by checking this webpage. Your continued use of this Website following changes to these Terms of Use constitutes your agreement to the revised Terms of Use.
`;
/* eslint-enable max-len */

// Organization Colors
export const COLOR_BLUE = "blue";
export const COLOR_GREEN = "green";
export const COLOR_RED = "red";
export const COLOR_ORANGE = "orange";
export const COLOR_PURPLE = "purple";
export const COLOR_BLACK = "black";
export const COLOR_YELLOW = "yellow";
export const COLOR_PINK = "pink";
export const COLOR_BROWN = "brown";

export const COLOR_LIST = [
  COLOR_BLUE,
  COLOR_GREEN,
  COLOR_ORANGE,
  COLOR_RED,
  COLOR_PURPLE,
  COLOR_YELLOW,
  COLOR_PINK,
  COLOR_BLACK,
  COLOR_BROWN,
];

// Time
export const millisecondsPerMinute = 1000 * 60;
export const millisecondsPerHour = millisecondsPerMinute * 60;
export const millisecondsPerDay = millisecondsPerHour * 24;

// Moment-compatible date format strings
export const DATE_FORMAT_ISO = "YYYY-MM-DD";
export const DATE_FORMAT_DISPLAY_NUMERIC = "MM/DD/YYYY";
export const DATE_FORMAT_DISPLAY_NUMERIC_SHORT = "M/D/YYYY";
export const DATE_FORMAT_DISPLAY_FULL = "dddd, MMMM Do YYYY";
export const DATE_FORMAT_DISPLAY_TEXT_LONG = "MMMM Do, YYYY";

export const DATETIME_FORMAT_UTC_OFFSET = "YYYY-MM-DD HH:mm:ssZ";
export const DATETIME_FORMAT_ISO = "YYYY-MM-DD HH:mm:ss";
export const DATETIME_FORMAT_HTML_ISO = "YYYY-MM-DDTHH:mm:ss";
export const DATETIME_DISPLAY_NUMERIC_LONG = "MM/DD/YYYY, hh:mm\xA0A";
export const DATETIME_DISPLAY_NUMERIC_FULL = "MM/DD/YYYY, hh:mm:ss\xA0A";
export const DATETIME_DISPLAY_TEXT_LONG = "MMMM D YYYY, h:mma";
export const DATETIME_FORMAT_24H = "YYYY-MM-DD HH:mm:ss";

export const TIME_FORMAT_UTC = "HH:mm:ssZ";
export const TIME_FORMAT_24H = "HH:mm:ss";
export const TIME_FORMAT_24H_MINUTES = "HH:mm";
export const TIME_FORMAT_12H_RANGED = "hh:mma";
export const TIME_FORMAT_12H_SHORT = "h:mm a";
export const TIME_FORMAT_DISPLAY_SHORT = "LT";
export const TIME_FORMAT_DISPLAY_SECONDS = "LTS";

// Spacing
const cardSpacing = 60 * 3;
export const appWidth = (ScreenWidth - cardSpacing) / 3;
export const appHeight = appWidth;
export const appIconSize = 60;
export const smallAppIconSize = 20;
export const modalIconSize = 50;
export const profilePictureSize = ScreenWidth < 500 ? appHeight * 0.5 : 50;
export const bannerImageSize = 250;
// User Roles
export const ROLE_USER = "fc64b450-f41e-4a45-b831-c94d684449fa";
export const ROLE_MESSAGING_MANAGER = "e15bc084-be82-41b2-bad3-6f7dfa5717e4";
export const ROLE_ADMIN = "c074b5ce-033a-4256-9731-a50d0e4531a9";

export const ROLE_NAMES = {
  [ROLE_USER]: "User",
  [ROLE_MESSAGING_MANAGER]: "Messaging Manager",
  [ROLE_ADMIN]: "Admin",
};

// Alert types
export const ALERT_TYPE_CRITICAL = "CRITICAL";
export const ALERT_TYPE_INFO = "INFO";

// Info alert subtypes
export const INFO_TYPE_REMINDER = "REMINDER";

// ContactInformation type
export const CONTACTINFO_TYPE_DEFAULT = "816ea5bc-e9a6-41d0-b079-fca368114b1f";
export const CONTACTINFO_TYPE_EMERGENCY =
  "f05dbfc7-b8a7-41e2-8ac8-fc92c64f3000";
export const CONTACTINFO_TYPE_CELLPHONE =
  "a59eea61-3fb8-4766-b241-99eaec772b43";

// OrganizationSystemDependency types
export const DEPENDENCY_TYPE_TEAM = "cc76b450-f8df-4e9f-bc49-3239d4e1f14b";
export const DEPENDENCY_TYPE_LOCATION = "d2d3f49e-45b3-44fc-bffd-f8a1ad6106d8";
export const DEPENDENCY_TYPE_ORGANIZATION =
  "af772bb2-dbde-4faf-b119-c59dee6f528c";

export const DEPENDENCY_TYPE_ID_NAME_MAP = {
  [DEPENDENCY_TYPE_TEAM]: "Team",
  [DEPENDENCY_TYPE_LOCATION]: "Location",
  [DEPENDENCY_TYPE_ORGANIZATION]: "Organization",
};

// Page data
export const ALERT_TABLE_COLUMNS = [
  { key: "name", label: "Name" },
  { key: "startTime", label: "Start Time" },
  { key: "status", label: "Status" },
  { key: "dismissedAt", label: "Resolved At" },
  { key: "resolution", label: "Resolution" },
];

// Table Pagination
export const TABLE_PAGE_SIZES = [1, 5, 10, 20, 50, 100];
export const SORT_OPTIONS = [
  "First Name (A-Z)",
  "First Name (Z-A)",
  "Last Name (A-Z)",
  "Last Name (Z-A)",
  "Status (A-Z)",
  "Status (Z-A)",
];
export const SORT_MAPPINGS = [
  { field: "firstName", direction: "asc" },
  { field: "firstName", direction: "desc" },
  { field: "lastName", direction: "asc" },
  { field: "lastName", direction: "desc" },
  { field: "status", direction: "asc" },
  { field: "status", direction: "desc" },
  // Person-focused sort mappings
  { field: "position", direction: "asc" },
  { field: "position", direction: "desc" },
  { field: "roleId", direction: "asc" },
  { field: "roleId", direction: "desc" },
];

// ContactCard Web
export const EXPANDED_HEIGHT = 200;
// Other
// export const BASE_URL = getIsProd()
//   ? process.env.BASE_URL_PRODUCTION
//   : process.env.BASE_URL_STAGING;

export const BASE_URL = process.env.BASE_URL;

export const mobileOverlayStyle = {
  overlay: {
    position: "absolute",
    width: "100%",
    height: "200%",
  },
};

export const webOverlayStyle = {
  overlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
};

export const isIpad = ScreenWidth >= 768;

export const ipadButtonStylingOnAuthStack = {
  maxWidth: 600,
  alignSelf: "center",
  width: "100%",
};

export const TEAM_TYPE = "Team";
export const SYSTEM_TYPE = "System";
export const LOCATION_TYPE = "Location";

export const TEAM_PRIMARY_LOCATION_TOOLTIP_TEXT =
  "The location directly tied to a team, e.g. ACME Staff (team) is a one to one representation of the employees at ACME Office (location). Teams like Development or Executives will most likely not have a primary location.";
export const TEAM_SECONDARY_LOCATION_TOOLTIP_TEXT =
  "The locations that are tied to this team in any way, e.g. Development (team) might have members that are located at ACME Staff California (location) and/or ACME Staff Virginia (location). Select all that apply.";
